import feature from 'vue-feature-toggle';
import config from '@/config';

feature.defaultVisibility(feature =>
  Boolean(config.enabledFeatures[feature.name])
);
Object.keys(config.enabledFeatures).map(featureString => {
  const [f, v] = featureString.split('-');
  feature.visibility(f, v, function({ name, variant }) {
    return f == name && v == variant;
  });
});

export default feature;



// WEBPACK FOOTER //
// ./src/feature.js